import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";
import RentalStatus from "../../enums/RentalStatus";

class RentalDateModal extends React.Component {
  render() {
    const {
      show,
      rental,
      startDate,
      endDate,
      isLoading,
      onClose,
      onStartDateChange,
      onEndDateChange,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const title = "Modifier les dates de location";
    const productName = rental.product ? rental.product.designation : "Produit";

    const formattedStartDate = startDate
      ? new Date(startDate + "T00:00:00").toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "";
    const formattedEndDate = endDate
      ? new Date(endDate + "T00:00:00").toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      : "";

    const getMinEndDate = () => {
      // Si la location est active, la date de fin ne peut pas être antérieure à aujourd'hui
      const today = new Date().toISOString().split("T")[0];

      if (startDate) {
        const nextDay = new Date(startDate);
        nextDay.setDate(nextDay.getDate() + 1);
        const nextDayStr = nextDay.toISOString().split("T")[0];

        // Si la location est active, prendre le maximum entre aujourd'hui et le jour après startDate
        if (rental.status === RentalStatus.ACTIF) {
          return nextDayStr > today ? nextDayStr : today;
        }
        return nextDayStr;
      }
      if (rental.start_date) {
        const nextDayAfterStart = new Date(rental.start_date);
        nextDayAfterStart.setDate(nextDayAfterStart.getDate() + 1);
        const nextDayStr = nextDayAfterStart.toISOString().split("T")[0];

        // Si la location est active, prendre le maximum entre aujourd'hui et le jour après start_date
        if (rental.status === RentalStatus.ACTIF) {
          return nextDayStr > today ? nextDayStr : today;
        }
        return nextDayStr;
      }
      return today;
    };

    const isConfirmDisabled = isLoading || !startDate;

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-date-modal"
      >
        <Modal.Header className="rental-modal-header-gradient">
          <Modal.Title className="rental-modal-title">
            <i className="fas fa-calendar-alt"></i>
            {title}
          </Modal.Title>
          {!isLoading && (
            <button
              type="button"
              onClick={onClose}
              className="rental-validation-modal-close-btn"
            >
              <span>&times;</span>
            </button>
          )}
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <div className="rental-modal-product-section">
              <div className="rental-modal-product-label">Produit</div>
              <div className="rental-modal-product-name">{productName}</div>
            </div>

            <div>
              <div className="rental-modal-form-group">
                <label htmlFor="startDate" className="rental-modal-form-label">
                  Date de début de location
                </label>
                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={onStartDateChange}
                  disabled={isLoading}
                  className="rental-modal-form-input"
                />
                {formattedStartDate && (
                  <div className="rental-modal-date-info-mt">
                    <i className="fas fa-calendar-check mr-2"></i>
                    {formattedStartDate}
                  </div>
                )}
              </div>

              <div className="rental-modal-form-group">
                <label htmlFor="endDate" className="rental-modal-form-label">
                  Date de fin de location
                </label>
                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={onEndDateChange}
                  disabled={isLoading}
                  min={getMinEndDate()}
                  className="rental-modal-form-input"
                />
                {formattedEndDate && (
                  <div className="rental-modal-date-info-mt">
                    <i className="fas fa-calendar-check mr-2"></i>
                    {formattedEndDate}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="rental-modal-btn-cancel"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            disabled={isConfirmDisabled}
            className={`rental-modal-btn-primary ${
              isConfirmDisabled
                ? "rental-modal-btn-primary-disabled"
                : "rental-modal-btn-primary-enabled"
            }`}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span>Chargement...</span>
              </>
            ) : (
              <>Confirmer</>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalDateModal;
